import { render, staticRenderFns } from "./ShopTournament.vue?vue&type=template&id=119dfd96"
import script from "./ShopTournament.vue?vue&type=script&lang=js"
export * from "./ShopTournament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports